<section class="about-section">
  <!-- Pierwszy wiersz: tekst O nas + zdjęcie about.png -->
  <h2 *ngIf="showFull">Cześć! Nazywamy się Guarana.</h2>
  <div class="about-row">
    <div class="about-text">
      <h2 *ngIf="!showFull">O nas</h2>
      <p>
        Gramy komediowe spektakle improwizowane. Jesteśmy charyzmatycznymi
        storytellerami, którzy z finezją balansują między absurdem i komentarzem
        rzeczywistości. Pod przykrywką komedii i głupoty przemycamy wartościowe
        refleksje o kondycji ludzi, relacji i świata. Poza sceną zajmujemy się
        komedią jako autorzy, scenarzyści, reżyserzy, instruktorzy impro,
        wokaliści, chemicy.
      </p>
      <button
        *ngIf="!showFull"
        mat-button
        routerLink="/o-nas"
        class="learn-more"
      >
        Poznaj nas
      </button>
    </div>
    <div class="about-image">
      <img src="./assets/img/about.png" alt="Guarana - O nas" />
    </div>
  </div>

  <!-- Drugi wiersz: 4 zdjęcia aktorów + tekst Poznaj nas -->
  <div *ngIf="showFull" class="actors-row">
    <div class="actors-images">
      <div class="actor">
        <img src="assets/img/Damian.png" alt="Damian Nieduziak" />
        <p>Damian Nieduziak</p>
      </div>
      <div class="actor">
        <img src="assets/img/Iza.jpg" alt="Izabela Brzezińska" />
        <p>Izabela Brzezińska</p>
      </div>
      <div class="actor">
        <img src="assets/img/Ola.jpg" alt="Ola Meljon-Pilawa" />
        <p>Ola Meljon-Pilawa</p>
      </div>
      <div class="actor">
        <img src="assets/img/Pawel.jpg" alt="Paweł Czub" />
        <p>Paweł Czub</p>
      </div>
    </div>

    <div class="poznaj-nas-text">
      <h3>Poznaj nas</h3>
      <p>
        Guarana to Damian Nieduziak, Izabela Brzezińska, Ola Meljon-Pilawa i
        Paweł Czub. Oficjalnie jako grupa istniejemy od 2023 r. Nieoficjalnie
        improwizujemy ze sobą znacznie dłużej. Mamy za sobą występ na I edycji
        festiwalu PIK (Warszawa). W każdy wtorek występujemy na warszawskiej
        scenie.
      </p>
      <p>
        Za konferansjerkę, muzykę, materiały foto i wideo oraz social media
        odpowiada nasza ninja – Justyna Sadlak.
      </p>
      <p>
        Wsparcia technicznego udziela nam Błażej Rozwoda – możecie go spotkać na
        bramce.
      </p>
    </div>
  </div>
</section>
